import ReactDOM from "react-dom";

// 动态列生成器函数
export function generateColumns(baseColumns, dynamicColumns, data) {
    // 数据校验
    if (!Array.isArray(baseColumns) || !Array.isArray(dynamicColumns)) {
        throw new TypeError('baseColumns and dynamicColumns must be arrays');
    }

    const finalColumns = [...baseColumns];

    dynamicColumns.forEach(columnConfig => {
        try {
            // 提取配置并进行边界条件检查
            const { checkFunction, position, render } = columnConfig;
            if (position < 0 || position > finalColumns.length) {
                throw new Error('Invalid position');
            }

            // 使用安全检查，确保 checkFunction 和 render 是函数
            if (typeof checkFunction !== 'function' || (render !== undefined && typeof render !== 'function')) {
                throw new TypeError('checkFunction and render must be functions');
            }

            // 执行检查函数
            if (checkFunction(data)) {
                const column = {
                    ...columnConfig,
                    // 确保 render 是安全的函数调用，避免XSS风险
                    render: typeof render === 'function' ? render : () => ''
                };
                finalColumns.splice(position, 0, column);
            }
        } catch (error) {
            // 异常处理逻辑，可以按需调整
            console.error('Error in generateColumns:', error);
            // 根据需要，可以选择抛出异常、记录日志或者进行其他处理
        }
    });

    return finalColumns;
}

// 获取当前元素到页面底部的距离
export function getOffsetHeight(dom) {
    if (dom) {
        let DomNode = ReactDOM.findDOMNode(dom);
        let offsetHeight = DomNode?.offsetHeight;
        if(offsetHeight) {
            return offsetHeight
        }
    }
    return 0
}

export function transferSpecialCharacter(value) {
    let arr = ['(', '[', '{', '/', '^', '$', '¦', '}', ']', ')', '?', '*', '+', '.', "'", '"']
    for (let i = 0; i < arr.length; i++) {
        if (value) {
            if (value.indexOf(arr[i]) > -1) {
                const reg = (str) => str.replace(/[\[\]\/\{\}\(\)\*\'\"\¦\+\?\.\\\^\$\|]/g, "\\$&")
                value = reg(value)
            }
        }
    }
    return value;
}

export function getMaxWidth(otherWidth=0) {
    let clientWidth = window.document.body.clientWidth;
    return clientWidth - getPageMargin()*2 - getAntTreeWidth() - otherWidth
};

// 获取左侧tree宽度
function getAntTreeWidth() {
    // 页面整体刷新时无法保证左侧树比右侧内容先渲染出来，临时默认显示左侧树
    return 240
    let antTree = document.getElementsByClassName("ant-tree");
    if(antTree?.length) {
        return 240
    }
    return 0
};

// 获取页面两端的外边距
function getPageMargin() {
    let clientWidth = window.document.body.clientWidth;
    let contentMarginScopeDefault = '[{"expression":">=1900","value":"140"},{"expression":"<1900","value":"40"}]';
    let contentMarginScope = window.sysConfigGetValueByKey("system.content.margin.scope", contentMarginScopeDefault);
    contentMarginScope = JSON.parse(contentMarginScope);
    let contentMarginValue = 40;
    for(let i = 0; i < contentMarginScope.length; i++){
        let contentMargin = contentMarginScope[i];
        let isTrue = eval(clientWidth + contentMargin.expression);
        if(isTrue){
            contentMarginValue = parseInt(contentMargin.value);
            break;
        }
    }
    return contentMarginValue
};

export function checkWidth(col,marginRight=24,otherW=0) {
    let data = {marginRight:marginRight,scale:1};
    if(col?.length) {
        let width = 0;
        let marginW = (col.length-1) * marginRight;
        let marginM = col.length * 5;
        col.forEach(item=>{
            let w = item?.component?.config?.style?.width || 0;
            width=width+w
        });
        let maxWidth = getMaxWidth(otherW);
        if(maxWidth < (width+marginW)) {
            if(maxWidth < (width+marginM)) {
                data.marginRight = 5;
            } else {
                data.marginRight = (maxWidth-width)/col.length
            }
        }
    }
    return data
}

